import styled, { css } from 'styled-components'
import { theme } from '~/styles'

export const Container = styled.div`
  display: flex;
  position: relative;
  flex: 1;
`

export interface IField {
  large?: boolean
  disable?: boolean
  error?: boolean
  active?: boolean
}

export const Field = styled.textarea<IField>`
  flex: 1;
  padding: 8px 16px;
  resize: none;
  outline: none;
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  border: 1px solid ${theme.colors.colorBCC9D9};
  min-height: 203px;
  display: flex;
  flex-wrap: wrap;
  font-family: 'Inter', sans-serif;
  ${props =>
    props.disable &&
    css`
      background: ${props.theme.colors.colore9ecf3};
      border: 1px solid ${props.theme.colors.colord4d9de};
      pointer-events: none;
    `}

  ${props =>
    props.error &&
    css`
      border: 1px solid ${theme.colors.colorFF2424};
    `}

  &:focus {
    border: 1px solid ${theme.colors.color378ff7};
  }

  &::placeholder {
    color: ${theme.colors.color6b7786};
    opacity: 0.5;
  }

  &::-ms-input-placeholder {
    color: ${theme.colors.color6b7786};
    opacity: 0.5;
  }

  &::-ms-input-placeholder {
    color: ${theme.colors.color6b7786};
    opacity: 0.5;
  }
`
